<div class="modal-header checkout-popup-header">
  <h4 class="modal-title" id="modal-basic-title">{{ "bulkorder.savingcart" | cxTranslate }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="dismissModal('Cross click')"
  >
    <i class="material-icons">close</i>
  </button>
</div>

<div class="modal-body checkout-popup">
  <p>
    {{ "bulkorder.modalcheckout" | cxTranslate }}
    
  </p>

  <div class="vs-text-field">
    <form  [formGroup]="cartModal">
    <label
      ><span class="custom-asterik">*</span>{{ "bulkorder.currentitem" | cxTranslate }}</label
    >
    <input  formControlName="cartid" name="cartid" type="text" [(ngModel)]="bulkModalCode1" [value]="bulkModalCode"/>
  </form>
  </div>
</div>

<div class="modal-footer checkout-popup-footer">
  <span (click)="dismissModal('Cross click')" class="mr custom-text"
    ><a class="footer-text-btn">{{ "bulkorder.cancelbtn" | cxTranslate }}</a></span
  >
  <button
    (click)="getNextBulkCode()"
    class="vs-primary-btn sample-btn footer-text-btn custom-width"
  >
  {{ "bulkorder.saveandproceedbtn" | cxTranslate }}
  </button>
</div>
